import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["yearSuffix", "priceSuffix", "yearInput"]

  show(event) {
    const year = Number(event.relatedTarget?.dataset.year);
    const description = this.yearDescription(year);

    if (this.hasYearSuffixTarget) this.yearSuffixTarget.textContent = description;
    if (this.hasYearInputTarget) this.yearInputTarget.value = description;
    if (this.hasPriceSuffixTarget) this.priceSuffixTarget.textContent = (year === 20201) ? "FREE" : "EUR 1995";
  }

  yearDescription(year) {
    return year === 20201 ? "1st Half 2020" : `Full Year ${year}`;
  }
}